import './EstateImage.21fb7c29a91a06b1383229b061a256dd.css';
export default {"svg":"_svg_1anpl_1"};